import { AsyncPipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgbAlert, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Config, ConfigurationService, NavigationService, PhxRouterStateSnapshot } from '@phx/core';
import { Observable } from 'rxjs';
import { authFeature, AuthState } from './auth/store/auth.state';

registerLocaleData(localeDe);

@Component({
    selector: 'phx-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        RouterLink,
        NgbAlert,
        RouterOutlet,
        AsyncPipe
    ]
})
export class AppComponent implements OnInit {
    title = 'merchant-cockpit';
    config: Config;
    routerState: PhxRouterStateSnapshot;
    navigationLinks: NavigationLink[] = [
        { url: '/kpis', name: 'KPIs' },
        { url: '/paymentMethods', name: 'Bezahlmethoden' },
        { url: '/transactions', name: 'Kontoübersicht & Transaktionen' },
        { url: '/logistics/dhl-de', name: 'DHL DE Onboarding' }
    ];
    user$: Observable<AuthState>;

    constructor(
        private configurationService: ConfigurationService,
        private navigationService: NavigationService,
        private store: Store
    ) {
        this.config = this.configurationService.getConfig();

        this.navigationService.routerStateSnapshot$.subscribe(routerState => {
            this.routerState = routerState;
        });
    }

    ngOnInit() {
        this.user$ = this.store.select(authFeature.selectAuthState);
    }
}

interface NavigationLink {
    url: string;
    name: string;
}
